'use strict';

var tslib = require('tslib');
var React = require('react');
var bemReactClassname = require('bem-react-classname');
var reactCircularProgressbar = require('react-circular-progressbar');
var cn = require('../../cn.js');
var themeProvider_themeProvider = require('../../theme-provider/theme-provider.js');
var core_circularTimer_utils = require('./utils.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

/**
 * Компонент для таймера.
 */
var CircularTimer = /** @class */ (function (_super) {
    tslib.__extends(CircularTimer, _super);
    function CircularTimer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cn = bemReactClassname.createCn('circular-timer');
        _this.state = {
            lastTimeMS: new Date().getTime(),
            timePassed: 0,
            intervalId: null,
            running: false,
        };
        /**
         * Запуск таймера
         */
        _this.start = function () {
            var _a = _this.state, timePassed = _a.timePassed, intervalId = _a.intervalId;
            var _b = _this.props, time = _b.time, onFinished = _b.onFinished;
            if (timePassed < time) {
                if (intervalId) {
                    window.clearInterval(intervalId);
                }
                var id = window.setInterval(function () {
                    var _a = _this.state, timePassed = _a.timePassed, lastTimeMS = _a.lastTimeMS;
                    var currentTimeMS = new Date().getTime();
                    var additionalTime = core_circularTimer_utils.TIME_STEP_MS;
                    // На случай, если с момента последнего апдейта прошло больше времени, чем шаг в MS, учитывать это время
                    // Например, если юзер свернул окно
                    if (currentTimeMS - lastTimeMS > core_circularTimer_utils.TIME_STEP_MS) {
                        additionalTime = currentTimeMS - lastTimeMS;
                    }
                    _this.setState({
                        timePassed: timePassed + core_circularTimer_utils.convertMSToS(additionalTime),
                        lastTimeMS: currentTimeMS,
                    }, function () {
                        if (timePassed >= time) {
                            _this.pause();
                            onFinished();
                        }
                    });
                }, core_circularTimer_utils.TIME_STEP_MS);
                _this.setState({
                    intervalId: id,
                    running: true,
                    lastTimeMS: new Date().getTime(),
                });
            }
            else {
                _this.setState({
                    timePassed: 0,
                }, function () {
                    _this.start();
                });
            }
        };
        /**
         * Поставить таймер на паузу
         */
        _this.pause = function () {
            window.clearInterval(_this.state.intervalId);
            _this.setState({
                running: false,
                intervalId: null,
            });
        };
        /**
         * Сброс таймера. Если manualStart false, то после сброса таймер автоматически стартанет
         */
        _this.reset = function () {
            _this.pause();
            _this.setState({
                timePassed: 0,
            }, function () {
                if (!_this.props.manualStart) {
                    _this.start();
                }
            });
        };
        /**
         * Ускорить таймер на timeToHasten секунд
         */
        // eslint-disable-next-line
        _this.hasten = function (timeToHasten) {
            var _a = _this.props, time = _a.time, onFinished = _a.onFinished;
            var _b = _this.state, timePassed = _b.timePassed, running = _b.running;
            if (timePassed < time && running) {
                if (timeToHasten + timePassed > time) {
                    timeToHasten = time - timePassed;
                    _this.pause();
                    onFinished();
                }
                _this.setState({
                    timePassed: timePassed + timeToHasten,
                });
            }
        };
        /**
         * Замедлить таймер на timeToSlowDown секунд
         */
        // eslint-disable-next-line
        _this.slowDown = function (timeToSlowDown) {
            var _a = _this.state, timePassed = _a.timePassed, running = _a.running;
            if (timePassed > 0 && running) {
                if (timePassed - timeToSlowDown < 0) {
                    timeToSlowDown = timePassed;
                }
                _this.setState({
                    timePassed: timePassed - timeToSlowDown,
                });
            }
        };
        return _this;
    }
    CircularTimer.prototype.componentDidMount = function () {
        var manualStart = this.props.manualStart;
        if (!manualStart) {
            this.start();
        }
        core_circularTimer_utils.fixStyles(this.cn('text'), this.cn('trail'));
    };
    CircularTimer.prototype.componentDidUpdate = function (prevProps) {
        var time = this.props.time;
        if (time !== prevProps.time) {
            this.reset();
        }
    };
    CircularTimer.prototype.componentWillUnmount = function () {
        window.clearInterval(this.state.intervalId);
    };
    CircularTimer.prototype.render = function () {
        var _a = this.props, time = _a.time, theme = _a.theme;
        var timePassed = this.state.timePassed;
        var formattedTimeLeft = core_circularTimer_utils.formatTimeLeft(this.timeLeft);
        return (React__default.default.createElement(themeProvider_themeProvider, { theme: theme },
            React__default.default.createElement(reactCircularProgressbar.CircularProgressbar, { value: timePassed, maxValue: time, strokeWidth: core_circularTimer_utils.STROKE_WIDTH, text: formattedTimeLeft, classes: {
                    root: this.cn(),
                    path: this.cn('path'),
                    trail: this.cn('trail'),
                    text: this.cn('text'),
                    background: '',
                } })));
    };
    Object.defineProperty(CircularTimer.prototype, "timeLeft", {
        /**
         * Время, оставшееся до завершения таймера, в секундах
         */
        get: function () {
            var time = this.props.time;
            var timePassed = this.state.timePassed;
            return time - Math.floor(timePassed);
        },
        enumerable: false,
        configurable: true
    });
    CircularTimer.defaultProps = {
        time: core_circularTimer_utils.DEFAULT_TIME_S,
        manualStart: false,
        onFinished: function () { },
    };
    return CircularTimer;
}(React__default.default.PureComponent));
/**
 * @visibleName CircularTimer
 */
var ThemedCircularTimer = /** @class */ (function (_super) {
    tslib.__extends(ThemedCircularTimer, _super);
    function ThemedCircularTimer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ThemedCircularTimer;
}(CircularTimer));
// eslint-disable-next-line no-class-assign
ThemedCircularTimer = cn.withTheme(CircularTimer);
var CircularTimer$1 = ThemedCircularTimer;

module.exports = CircularTimer$1;
